import { useState } from 'react'
import { TextField, Typography } from '@mui/material'
import GGButton from '../../../CommonComponents/GGButton/GGButton';
import { BuyerAPIHandler } from '../../../../services/NetworkClient/BackendAPIs/BuyerAPIHandler';
import Lottie from 'lottie-react';
import loaderLottie from '../../../../assets/lottie_animations/bubble-loader.json';
import { AuthAPIHandler } from '../../../../services/NetworkClient/BackendAPIs/AuthAPIHandler';

interface ChangePasswordPasswordEntryPageProps {
    email: string,
    moveToForgotPasswordPage: any,
    moveToNextPage: any
}

const ChangePasswordPasswordEntryPage = ({ email, moveToNextPage, moveToForgotPasswordPage }: ChangePasswordPasswordEntryPageProps) => {
    const [error, setError] = useState("");
    const [password, setPassword] = useState("");
    const [isloading, setIsloading] = useState(false);

    const handleChangePasswordFlow = async () => {

        setIsloading(true)
        setError("")
        try {
            await AuthAPIHandler.shared.login(email, password)
            moveToNextPage()
        } catch (err) {
            setError(err as string)
        } finally {
            setIsloading(false)
        }

    }

    const handleForgotPasswordFlow = async () => {
        setIsloading(true)
        setError("")
        try {
            await BuyerAPIHandler.shared.sendOtpForResetPassword(email)
            moveToForgotPasswordPage()
        } catch (err) {
            setError(err as string)
        } finally {
            setIsloading(false)
        }

    }

    const handlePasswordChange = (event: any) => {
        setPassword(event.target.value)
        setError("")
    }

    return (
        <div className='forgot-password-email-page'>
            <Typography marginBottom={"15px"}>Please enter existing password for verification for your account with email - <b> {email} </b></Typography>

            <TextField label='Enter old password' value={password} fullWidth onChange={handlePasswordChange} type='password' error={!!error}
                helperText={
                    <Typography color={'error'} variant='caption'>{error}</Typography>
                } />
            {
                isloading ?
                    <Lottie className="loader-lottie" animationData={loaderLottie} loop={true}></Lottie> :
                    <div className='button-section'>
                        <GGButton className='btn-secondary' variant='text' onClick={handleForgotPasswordFlow}>
                            Forgot Password?
                        </GGButton>

                        <GGButton className='btn-primary' onClick={handleChangePasswordFlow} >
                            Proceed
                        </GGButton>
                    </div>
            }
        </div>
    )
}


export default ChangePasswordPasswordEntryPage